import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { externalCalendarPreference } from "../../../../../../../services/externalCalendarPreference.service";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutomationReceivedRulePreference.";

export const CalendarPreferences = () => {
  const { t } = useTranslation();

  const { sendRequest: externalCalendarPreferenceRequest } = useFetch(
    externalCalendarPreference,
  );

  const [calendarPreferencesOptions, setCalendarPreferencesOptions] =
    useState<ISelectType[]>();

  const fetchExternalCalendarPreference = useCallback(async () => {
    const { data, success } = await externalCalendarPreferenceRequest({
      tasyScheduleTypeCode: 3,
      enableCode: true,
    });
    if (data && success) {
      const newData = data.map((item) => ({
        id: item.identifier.toString(),
        name: item.preference,
      }));
      setCalendarPreferencesOptions(newData);
    }
  }, [externalCalendarPreferenceRequest]);

  useEffect(() => {
    fetchExternalCalendarPreference();
  }, [fetchExternalCalendarPreference]);

  return (
    <Grid item xs={12} sm={12}>
      <AutoCompleteMulti
        name="calendarPreferences"
        label={t(translationPath + "calendar_preferences")}
        getOptionLabel={({ name }) => name}
        options={calendarPreferencesOptions}
        size="small"
        keepOpenOnSelect
      />
    </Grid>
  );
};
